import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
} from '@cargomatic/ui';
import { withTranslation } from 'react-i18next';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import UserActionCreators from '../../../actions/UserActionCreators';

function getEmptyState() {
  return {
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    password: '',
  };
}

class RegisterUserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = getEmptyState();
  }

  onChange = (key) => (e) => {
    this.setState({ [key]: e.target.value });
  };

  close = () => {
    this.setState(getEmptyState());
    this.props.onHide();
  };

  handleOpenChange = (open) => {
    if (!open) this.close();
  };

  register = (e) => {
    if (e) e.preventDefault();
    UserActionCreators.addAdminUser(this.state);
    this.close();
  };

  render() {
    const { t, show } = this.props;
    const disabled =
      _.isEmpty(this.state.username) ||
      _.isEmpty(this.state.email) ||
      _.isEmpty(this.state.first_name) ||
      _.isEmpty(this.state.last_name) ||
      _.isEmpty(this.state.password);

    return (
      <Dialog open={show} onOpenChange={this.handleOpenChange}>
        <DialogContent className="sm:max-w-[480px]">
          <DialogHeader>
            <DialogTitle>{t('REGISTER_AN_ADMIN_USER')}</DialogTitle>
          </DialogHeader>

          <form onSubmit={this.register} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="register-user-username">{t('USERNAME')}</Label>
              <Input
                id="register-user-username"
                type="text"
                value={this.state.username}
                onChange={this.onChange('username')}
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="register-user-email">{t('EMAIL')}</Label>
              <Input
                id="register-user-email"
                type="text"
                placeholder="example@cargomatic.com"
                value={this.state.email}
                onChange={this.onChange('email')}
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="register-user-first-name">
                {t('FIRST_NAME')}
              </Label>
              <Input
                id="register-user-first-name"
                type="text"
                placeholder="John"
                value={this.state.first_name}
                onChange={this.onChange('first_name')}
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="register-user-last-name">{t('LAST_NAME')}</Label>
              <Input
                id="register-user-last-name"
                type="text"
                placeholder="Smith"
                value={this.state.last_name}
                onChange={this.onChange('last_name')}
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="register-user-password">{t('PASSWORD')}</Label>
              <Input
                id="register-user-password"
                type="password"
                value={this.state.password}
                onChange={this.onChange('password')}
              />
            </div>

            <DialogFooter>
              <Button type="button" variant="outline" onClick={this.close}>
                {titleize(t('CLOSE'))}
              </Button>
              <Button type="submit" disabled={disabled}>
                {t('REGISTER')}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withTranslation()(RegisterUserForm);
